import * as Yup from 'yup'

export default Yup.object().shape({
	password: Yup.string()
		.min(8, 'Your password needs to have at least 8 characters.')
		.required('Email is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
})